export default __webpack_public_path__ + "static/media/last-image.a52029aa.png";